import { useAppContext } from '@app-velocity/config';
import { useI18n } from '@app-velocity/i18n';
import { OpenIcon } from '@app-velocity/icons';
import { ButtonsContainer, Button } from '@app-velocity/ui';

export type WhereToStartLinksProps = {
  variant?: 'contained';
};

export const WhereToStartLinks = ({ variant }: WhereToStartLinksProps) => {
  const { t } = useI18n();

  const { scenarioExample, scenarioDemo } = useAppContext();

  const openExample = (e: React.MouseEvent) => {
    e.stopPropagation();

    window.open(scenarioExample);
  };

  const openDemo = (e: React.MouseEvent) => {
    e.stopPropagation();

    window.open(scenarioDemo);
  };

  return (
    <ButtonsContainer>
      <Button
        size="small"
        onClick={openExample}
        color="secondary"
        variant={variant}
      >
        {t('shared:where_to_start.example')}
        <OpenIcon />
      </Button>
      <Button
        size="small"
        onClick={openDemo}
        color="secondary"
        variant={variant}
      >
        {t('shared:where_to_start.watch_demo')}
        <OpenIcon />
      </Button>
    </ButtonsContainer>
  );
};
